import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'zn-tab',
  template: `<ng-template><ng-content></ng-content></ng-template>`
})
export class ZnTabComponent {
  @Input() name!: string;
  @Input() title!: string;
  @Input() active = false;
  @Input() disabled = false;

  @ViewChild(TemplateRef, { static: true }) content!: TemplateRef<any>;
}